import { apiClient } from "./apiClient";

export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  stock: number;
  category: string;
  images: string[];
  materials?: string;
  size?: string;
  idealFor?: string;
  isFeaturedProduct?: boolean;
  enableMaterialType?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateProductData {
  name: string;
  description: string;
  price: number;
  stock: number;
  category: string;
  images: string[];
  materials?: string;
  size?: string;
  idealFor?: string;
  isFeaturedProduct?: boolean;
  enableMaterialType?: boolean;
}

export interface UpdateProductData {
  name?: string;
  description?: string;
  price?: number;
  stock?: number;
  category?: string;
  images?: string[];
  materials?: string;
  size?: string;
  idealFor?: string;
  isFeaturedProduct?: boolean;
  enableMaterialType?: boolean;
}

export const productService = {
  // Get all products (public)
  getAllProducts: async (): Promise<Product[]> => {
    return apiClient.get<Product[]>("/products");
  },

  // Get single product (public)
  getProduct: async (id: string): Promise<Product> => {
    return apiClient.get<Product>(`/products/${id}`);
  },

  // Create product (admin only)
  createProduct: async (data: CreateProductData): Promise<Product> => {
    return apiClient.post<Product>("/products", data, true);
  },

  // Update product (admin only)
  updateProduct: async (
    id: string,
    data: UpdateProductData
  ): Promise<Product> => {
    return apiClient.put<Product>(`/products/${id}`, data, true);
  },

  // Delete product (admin only)
  deleteProduct: async (id: string): Promise<void> => {
    return apiClient.delete<void>(`/products/${id}`, true);
  },
};
